import React, { useEffect, useState } from 'react';
import { useGetSearchResults } from './hooks/useGetSearchResults';
import { useFetchFavorites } from './hooks/useFetchFavorites';
//-------------------------------------------------------------------------------------------
import EpgTransactions from '../Player/components/EpgTransactions/EpgTransactions';
import SearchInput from './components/SearchInput';
import SearchResultsContainer from './components/SearchResultsContainer';
import './style.scss';
import { useRedirectToTalentPage } from './hooks/useRedirectToTalentPage';

//Este componente es el layout de la vista de busqueda
const NewSearchPage = () => {
  // Variable para la busqueda de contenido
  const [searchValue, setSearchValue] = useState('');
  useGetSearchResults(searchValue);
  useFetchFavorites();
  useRedirectToTalentPage();

  return (
    <div className="new-search-page">
      <SearchInput value={searchValue} onChangeText={setSearchValue} />
      <SearchResultsContainer value={searchValue} />
    </div>
  );
};

export default NewSearchPage;
